export const telemetryParameterMap = {
    'btf': { description: 'Weak battery', type: 'bool' },
    'ocs': { description: 'Iddle use', type: 'bool' },
    'svu': { description: 'Severe use', type: 'bool' },
    'tpa': { description: 'Engine coolant temperature', type: 'int' },
    'tda': { description: 'Air Discharge Temperature', type: 'double' },
    'pda': { description: 'Air Discharge Pressure', type: 'double' },
    'toh': { description: 'Hydraulic oil temperature', type: 'int' },
    'tpt': { description: 'Transmission temperature', type: 'int' },
    'cbc': { description: 'Fuel consumption', type: 'double' },
    'cbt': { description: 'Fuel level', type: 'int' },
    'hor': { description: 'Hourmeter', type: 'int' },
    'hod': { description: 'Hodometer', type: 'int' },
    'erc': { description: 'Day errors', type: 'int' },
    'hrb': { description: 'Hourmeter B', type: 'int' },
    'err': { description: 'Failure code', type: 'string' },
    'pcb': { description: 'Fuel pressure', type: 'double' },
    'pom': { description: 'Engine oil pressure', type: 'double' },
    'ptb': { description: 'Turbo pressure', type: 'double' },
    'tbt': { description: 'Battery voltage', type: 'int' },
    'kmh': { description: 'Speed', type: 'int' },
    'cgm': { description: 'Engine load', type: 'int' },
    'rpm': { description: 'Rpm', type: 'int' },
    'mat': { description: 'Current Gear', type: 'int' },
    'ret': { description: 'Transmission Retarder level', type: 'int' },
    'mtt': { description: 'Transmission max temperature', type: 'int' },
    'tuo': { description: 'Iddle use time', type: 'int' },
    'tus': { description: 'Severe use time', type: 'int' },
    'pan': { description: 'Panic', type: 'int' },
    'mta': { description: 'Engine max temperature', type: 'int' },
    'mcc': { description: 'Max consumption', type: 'int' },
    'mov': { description: 'Moving', type: 'int' },
    'mth': { description: 'Hydraulic max temperature', type: 'int' },
    'fmi': { description: 'Failure mode', type: 'int' },
    'tam': { description: 'Intake air temp', type: 'int' },
    'rfi': { description: 'RFID', type: 'int' },
    'soc': { description: 'Power Battery Charge', type: 'int' },
    'soh': { description: 'Power Battery Life', type: 'int' },
    'ttb': { description: 'Power Battery Volts', type: 'int' },
    'tpb': { description: 'Power Battery Temperature', type: 'int' },
    'bus': { description: 'Compass', type: 'int' },
    'uer': { description: 'Last error', type: 'int' },
    'uef': { description: 'Last error FMI', type: 'int' },
    'dtc': { description: 'DTC', type: 'string' },
    'tct': { description: 'DTC Type', type: 'int' },
    'prh': { description: 'Hydraulic pressure', type: 'int' },
    'rdo': { description: 'Network Origin', type: 'int' },
    'acx': { description: 'X-Axis Acceleration', type: 'int' },
    'acy': { description: 'Y-Axis Acceleration', type: 'int' },
    'acz': { description: 'Z-Axis Acceleration', type: 'int' },
    'hof': { description: 'Hourmeter offset', type: 'decimal' },
    'tom': { description: 'Engine oil temperature', type: 'double' },
    'acl': { description: 'Acceleration', type: 'double' },
    'ilt': { description: 'Lateral inclination Angle', type: 'int' },
    'ilg': { description: 'Longitudinal inclination Angle', type: 'int' },
    'cab': { description: 'Harsh Acceleration Counter', type: 'int' },
    'cfb': { description: 'Harsh Break Counter', type: 'int' },
    'mkm': { description: 'Max Speed', type: 'int' },
    'mtq': { description: 'Motor Torque', type: 'int' },
    'cvr': { description: 'RPM Speed Violation Counter', type: 'int' },
    'ibt': { description: 'Power Battery Current', type: 'int' },
    'tec': { description: 'Accumulated charged electric quantity', type: 'int' },
    'ted': { description: 'Accumulated discharged electric quantity', type: 'int' },
    'sec': { description: 'Single-charge electric quantity', type: 'int' },
    'crg': { description: 'Cargo Weight', type: 'int' },
    'opc': { description: 'Cargo Operation', type: 'int' },
    'ccc': { description: 'Cargo Cycles Count', type: 'int' },
    'tcg': { description: 'Total Cargo Weight', type: 'double' },
    'cpn': { description: 'Tire count', type: 'int' },
    't01': { description: 'Tire 1 temperature', type: 'int' },
    't02': { description: 'Tire 2 temperature', type: 'int' },
    't03': { description: 'Tire 3 temperature', type: 'int' },
    't04': { description: 'Tire 4 temperature', type: 'int' },
    't05': { description: 'Tire 5 temperature', type: 'int' },
    't06': { description: 'Tire 6 temperature', type: 'int' },
    't07': { description: 'Tire 7 temperature', type: 'int' },
    't08': { description: 'Tire 8 temperature', type: 'int' },
    't09': { description: 'Tire 9 temperature', type: 'int' },
    't0a': { description: 'Tire 10 temperature', type: 'int' },
    'p01': { description: 'Tire 1 pressure', type: 'int' },
    'p02': { description: 'Tire 2 pressure', type: 'int' },
    'p03': { description: 'Tire 3 pressure', type: 'int' },
    'p04': { description: 'Tire 4 pressure', type: 'int' },
    'p05': { description: 'Tire 5 pressure', type: 'int' },
    'p06': { description: 'Tire 6 pressure', type: 'int' },
    'p07': { description: 'Tire 7 pressure', type: 'int' },
    'p08': { description: 'Tire 8 pressure', type: 'int' },
    'p09': { description: 'Tire 9 pressure', type: 'int' },
    'p0a': { description: 'Tire 10 pressure', type: 'int' },
    'vvt': { description: 'Wind speed', type: 'int' },
    'cpl': { description: 'Crane Boom Length', type: 'int' },
    'agl': { description: 'Crane Boom Angle', type: 'int' },
    'ral': { description: 'Crane Working Radius', type: 'int' },
    'cag': { description: 'Crane Actual Load', type: 'int' },
    'cng': { description: 'Crane Rated Capacity', type: 'int' },
    'pcg': { description: 'Crane Load Percentage', type: 'int' },
    'alg': { description: 'Crane Boom Tip Height', type: 'int' },
    'arg': { description: 'Crane Slew Angle', type: 'int' },
    'icg': { description: 'Crane Machine Inclination', type: 'int' }
};

function parseTelemetryValue(value, type) {
    if (value === null || value === undefined) return value;

    switch (type) {
        case 'int':
        case 'double':
        case 'decimal': {
            const numericValue = Number(value);
            return Number.isNaN(numericValue) ? value : numericValue;
        }
        case 'bool':
            if (typeof value === 'boolean') return value;
            if (typeof value === 'number') return value === 1;
            if (typeof value === 'string') {
                const lowered = value.toLowerCase();
                if (lowered === 'true') return true;
                if (lowered === 'false') return false;
                const numeric = Number(value);
                if (!Number.isNaN(numeric)) return numeric === 1;
            }
            return Boolean(value);
        default:
            return value;
    }
}

function parseDateString(dateString) {
    if (!dateString) return null;
    
    // Tenta parsear formato "DD/MM/YYYY HH:mm"
    const ddmmyyyyPattern = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/;
    const match = dateString.match(ddmmyyyyPattern);
    
    if (match) {
        const [, day, month, year, hour, minute] = match;
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute));
        return !Number.isNaN(date.getTime()) ? date : null;
    }
    
    // Fallback para Date padrão
    const date = new Date(dateString);
    return !Number.isNaN(date.getTime()) ? date : null;
}

export function processTelemetryData(responseData) {
    if (!responseData || !Array.isArray(responseData)) {
        return [];
    }

    const filteredData = responseData.filter(item => {
        return telemetryParameterMap.hasOwnProperty(item.parameterName);
    });

    const formattedData = filteredData.map(item => {
        const displayInfo = telemetryParameterMap[item.parameterName];
        const parsedValue = parseTelemetryValue(item.parameterValue, displayInfo.type);
        const receivedAt = parseDateString(item.parameterDate);

        return {
            assetId: item.assetId,
            parameterDate: item.parameterDate,
            receivedAt,
            code: item.parameterName,
            value: parsedValue,
            rawValue: item.parameterValue,
            description: displayInfo.description,
            type: displayInfo.type,
            systemTypeName: item.systemTypeName || null
        };
    });

    return formattedData;
}